/* Tabbed Contents Block JS File */
$(document).ready(function() {
	// $('.tabbed-content-tab').tab();
	if ($('.tabbed-contents-block').length > 0) {

	}
	matchHeight('.tabbed-contents-wrapper .tab-pane');
});
